import { useQuery } from '@apollo/client';
import { Trans } from '@lingui/react/macro';
import { Button, Loader } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { TeamsAndUsersMenu } from 'app/domains/common-ui';
import { useTeamMembers, useTeamRole, useAddTeamMembers, useDeleteTeamMember } from 'app/domains/teams';
import { useRole } from 'app/domains/users';
import { AddTeamMembersButtonDocument } from './AddTeamMembersButton.gql';
export function AddTeamMembersButton(props) {
    const { teamId } = props;
    const { addTeamMembers } = useAddTeamMembers();
    const { deleteTeamMember } = useDeleteTeamMember();
    const { teamMembers, loading: loadingMembers, error: errorMembers } = useTeamMembers(teamId);
    const { data, loading: loadingUsers, error: errorUsers } = useQuery(AddTeamMembersButtonDocument);
    const error = errorMembers || errorUsers;
    const loading = loadingMembers || loadingUsers;
    const role = useRole();
    const teamRole = useTeamRole(teamId);
    const canAddMembers = role.can('invite:team_member') || teamRole.can('invite:team_member');
    const existingUserIds = teamMembers.map(({ userId }) => userId);
    const handleSelect = (item) => {
        if (item.type !== 'user') {
            return;
        }
        const member = teamMembers.find((teamMember) => teamMember.userId === item.user.userId);
        if (member) {
            deleteTeamMember({ teamId, memberId: member.id });
        }
        else {
            addTeamMembers(teamId, [item.user.userId]);
        }
    };
    if (!canAddMembers || error) {
        return null;
    }
    return (<TeamsAndUsersMenu type="users" from={data || {}} selectedIds={existingUserIds} onSelect={handleSelect} renderTarget={({ setOpen, open }) => (<Button onClick={() => setOpen(!open)}>
          {loading ? <Loader /> : <Falcon icon="add"/>}
          <Trans comment="add team members dropdown button text">Add member</Trans>
        </Button>)}/>);
}
